<script>
import Layout from "@layouts/form";
import Tarefa from "@forms/Tarefa";

export default {
  page: {
    title: "Detalhes | Tarefa"
  },
  components: { Layout, Tarefa },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    copy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Tarefa",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Tarefa",
          href: "/Tarefa"
        },
        {
          text: this.copy ? "Copiar" : "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Tarefa :editable="editable" :copy="copy"></Tarefa>
    </div>
  </Layout>
</template>
